import React from 'react';

export default function useLayoutRect(ref, condition) {
  const [rect, setRect] = React.useState({
    uninitialized: true,
    left: 0,
    top: 0,
    width: 0,
    height: 0,
  });

  React.useLayoutEffect(() => {
    if (!ref.current) return;
    const boundingRect = ref.current.getBoundingClientRect();
    if (['left', 'top', 'width', 'height'].every(attr => boundingRect[attr].toFixed(0) === rect[attr].toFixed(0))) return;
    setRect({
      left: boundingRect.left,
      top: boundingRect.top,
      width: boundingRect.width,
      height: boundingRect.height,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, condition);

  return rect;
}
